import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  REQUEST(state, request) {
    state.cached = request
  },
}

export const actions = {

  init({ state, dispatch }) { },

  fetchRequests(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/requests/${query}`).then((response) => {
      const request = response.data
      context.commit('REQUEST', request)
      return request
    })
  },

  fetchRequestsContabilidad(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/requests/contabilidad/${query}`).then((response) => {
      const request = response.data
      context.commit('REQUEST', request)
      return request
    })
  },


  fetchRequestOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/requests/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchRequestDetail(context, id) {
    return axios.get(`${serverUrl}/api/requests/${id}/`).then((response) => {
      return response.data
    })
  },

  fetchRequestProjects(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/requests/projects/${query}`).then((response) => {
      return response.data
    })
  },


  fetchRequestResourcesOverview(context, payload) {
    payload.query = payload.query || ''
    return axios.get(`${serverUrl}/api/request/schedule/${payload.id}/overview/${payload.query}`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  fetchRequestResourcesLegalization(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/api/scheduling/${payload.id}/legalization/`).then((response) => {
      const request = response.data
      // context.commit('SCHEDULE', request)
      return request
    })
  },

  putRequestResourcesLegalization(context, data) {
    let promise = axios.put(`${serverUrl}/api/scheduling/${data.id}/legalization/`, data.payload)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  createUpdateRequest(context, formData) {
    let promise = null
    if (formData.url) {
      promise = axios.put(formData.url, formData)
    } else {
      promise = axios.post(`${serverUrl}/api/requests/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  actionRequest(context, payload) {
    let promise = axios.patch(`${serverUrl}/api/requests/${payload.id}/action/`, payload.data)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  againRequest(context, payload) {
    let promise = axios.patch(`${serverUrl}/api/requests/${payload.id}/again/`, payload.data)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  reportRequest(context, payload) {
    let promise = axios.get(`${serverUrl}/api/requests/${payload.report_id}/report/?accounting=${payload.accounting}`, payload.type)
    return promise.then(
      (response) => {
        return response
      }
    )
  },

  deleteRequest(context, id) {
    let promise = null
    promise = axios.delete(`${serverUrl}/api/requests/${id}/delete`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  // Files
  fetchRequestFiles(context, payload) {
    return axios.get(`${serverUrl}/api/requests/${payload.request_id}/files/`).then((response) => {
      return response.data
    })
  },

  fetchRequestScheduleFiles(context, payload) {
    return axios.get(`${serverUrl}/api/request/schedule/${payload.schedule_id}/files/`).then((response) => {
      return response.data
    })
  },

  deleteRequestFile(context, payload) {
    return axios.delete(`${serverUrl}/api/requests/${payload.request_id}/files/${payload.file_id}`).then((response) => {
      return response.data
    })
  },

}